'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$61() {
  this.aVi = null;
  this.aVj = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$61 as $c_Lpresto_GroupRestrictionsView$$anon$61 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$61.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$61;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$61() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$61 as $h_Lpresto_GroupRestrictionsView$$anon$61 };
$h_Lpresto_GroupRestrictionsView$$anon$61.prototype = $p;
$p.P = (function() {
  if ((!this.aVj)) {
    this.aVi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aVj = true;
  }
  return this.aVi;
});
var $d_Lpresto_GroupRestrictionsView$$anon$61 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$61, "presto.GroupRestrictionsView$$anon$61", ({
  J6: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$61 as $d_Lpresto_GroupRestrictionsView$$anon$61 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$61.js.map
